import { IconButton } from '@mui/material';
import {useState} from 'react';
import new_download_icon from "../../../asset/image/new_download_icon.svg";

interface DownloadButtonProps {
    handleDownloadReport?: () => void;
}

const DownloadButton = (props: DownloadButtonProps) => {
    const {handleDownloadReport} = props;
    return(
        <IconButton
            onClick={handleDownloadReport}
            sx={{
              width: 28,
              height: 29,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              }}
        >
            <img src={new_download_icon}></img>
        </IconButton>
    )
}

export default DownloadButton;